import conditionalComponent from './conditionalComponent';

export default conditionalComponent('Failed', {
  all: 'allFailed',
  any: 'anyFailed',
});



// WEBPACK FOOTER //
// ./app/javascript/requests/components/Failed.js